import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = { class: "space-y-2" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-6 md:grid-cols-5" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mb-1 font-semibold" }
const _hoisted_8 = { class: "mb-1 font-semibold" }
const _hoisted_9 = { class: "whitespace-pre-wrap break-words" }
const _hoisted_10 = { class: "flex justify-end px-4 sm:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('script.view.title')), 1 /* TEXT */)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: { name: 'ListScript' } }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_UiButton, {
                "text-variant": "primary",
                "no-border": "",
                "no-shadow": "",
                class: "hover:bg-white/50"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Back')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })), [
                [_directive_tippy, _ctx.$t('core.actions.Back')]
              ])
            ]),
            _: 1 /* STABLE */
          }),
          (_ctx.$can($setup.Permission.EDIT_SCRIPT))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
                            name: 'EditScriptById',
                            params: {
                                id: $setup.route.params.id,
                            },
                        },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiPanel, { class: "flex px-4 py-2" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('script.labels.clientUrl')), 1 /* TEXT */),
              _createElementVNode("p", null, _toDisplayString($setup.script?.clientUrl), 1 /* TEXT */)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('script.labels.includeJquery')), 1 /* TEXT */),
              _createElementVNode("p", {
                class: _normalizeClass([[
                                $setup.script?.includeJquery
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800',
                            ], "inline-flex rounded-full px-2 text-sm font-semibold leading-5"])
              }, _toDisplayString($setup.script?.includeJquery
                                    ? _ctx.$t('core.options.Active')
                                    : _ctx.$t('core.options.Inactive')), 3 /* TEXT, CLASS */)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('script.labels.isActive')), 1 /* TEXT */),
              _createElementVNode("p", {
                class: _normalizeClass([[
                                $setup.script?.isActive
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800',
                            ], "inline-flex rounded-full px-2 text-sm font-semibold leading-5"])
              }, _toDisplayString($setup.script?.isActive
                                    ? _ctx.$t('core.options.Active')
                                    : _ctx.$t('core.options.Inactive')), 3 /* TEXT, CLASS */)
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }),
      ($setup.script?.isActive)
        ? (_openBlock(), _createBlock(_component_UiPanel, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("pre", _hoisted_9, _toDisplayString($setup.scripts), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_UiButton, {
                  variant: "white",
                  "text-variant": "gray-500",
                  class: "mt-4 overflow-auto",
                  onClick: $setup.copyToClipboard
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('script.actions.copyToClipboard')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}